import { lazy } from "react";

// Client Setting - ManufacturingJournal Template
// export const BOMSavedTemplate = lazy(
//   () => import("./ClientSettings/BOMSavedTemplate")
// );

/******  Before Auth Start ********/

export const Login = lazy(() => import("./Login/Login"));
export const SignUp = lazy(() => import("./SignUp/SignUp"));
export const AuSignUp = lazy(() => import("./AuSignup/AuSignUp"));

export const ForgotPassword = lazy(
  () => import("./ForgotPassword/ForgotPassword")
);
export const ResetForgetPassword = lazy(
  () => import("./ResetForgetPassword/ResetForgetPassword")
);
export const PricingCalculator = lazy(() => import("./Pricing/index"));

/******  Before Auth End ********/

/******* AFTER AUTH *************/

/****** HOME, PROFILE, MYSPACE ******/

// Home & Profile
export const Home = lazy(() => import("./Home/Home"));
export const Profile = lazy(() => import("./Profile/Profile"));
export const Settings = lazy(() => import("./Settings/index"));

// My Space
export const MySpace = lazy(() => import("./MySpace/index"));
export const CheckInScheduleList = lazy(
  () => import("./MySpace/CheckInScheduleList")
);
export const LoggedInUserProfileDetails = lazy(
  () => import("./MySpace/LoggedInUserProfileDetails")
);
export const LoggedInUsersAttendanceReport = lazy(
  () => import("./MySpace/LoggedInUsersAttendanceReport")
);
export const AllLeavesAndWHF = lazy(() => import("./MySpace/AllLeavesAndWHF"));
export const ApprovedAndPendingLeaves = lazy(
  () => import("./MySpace/Manager/index")
);
export const ApprovedAndPendingWFH = lazy(
  () => import("./MySpace/Manager/ApprovedAndPendingWFH")
);
export const LeaveAndWFHDetails = lazy(
  () => import("./MySpace/Manager/LeaveAndWFHDetails")
);
export const AddPEForm = lazy(() => import("./MySpace/PEFormModule/AddPEForm"));
export const PerformanceEvaluationList = lazy(
  () => import("./MySpace/PEFormModule/PerformanceEvaluationList")
);

/****** HOME, PROFILE, MYSPACE */

/********** Client Dashboard  ************/
export const ClientDashboard = lazy(
  () => import("./ClientDashboard/ClientDashboard")
);

// Invoicing
export const AddInvoice = lazy(() => import("./Invoicing/AddInvoice"));
export const EditInvoice = lazy(() => import("./Invoicing/EditInvoice"));
export const InvoiceListings = lazy(
  () => import("./Invoicing/InvoiceListings")
);
export const BulkUpload = lazy(() => import("./Invoicing/BulkUpload"));

// Invoice Generation
export const AddEditOtherEntryInvoice = lazy(
  () => import("./InvoiceGeneration/AddEditOtherEntryInvoice")
);
export const OtherCopyInvoice = lazy(
  () => import("./InvoiceGeneration/OtherCopyInvoice")
);
export const AddBillOfMaterial = lazy(
  () => import("./InvoiceGeneration/AddBillOfMaterial")
);
export const EditBillOfMaterial = lazy(
  () => import("./InvoiceGeneration/EditBillOfMaterial")
);
export const Einvoice = lazy(() => import("./InvoiceGeneration/Einvoice"));
export const EinvoiceSteps = lazy(() => import("./Einvoice"));
export const EwayBillSteps = lazy(() => import("./EwayBillStep"));

// Upload Document
export const DocumentList = lazy(() => import("./Documents"));
export const FileManager = lazy(() => import("./FileManager"));
export const SearchFileManager = lazy(
  () => import("./FileManager/SearchFileManager")
);

// Job Tracker Listing
export const JobTrackerListing = lazy(
  () => import("./JobTrackerListing/JobTrackerListing")
);

// Insights
export const InsightsDashboard = lazy(
  () => import("./Insights/InsightsDashboard")
);
export const InvoiceDetail = lazy(
  () => import("./Insights/Invoicing/InvoiceDetail")
);

// Insights Advanced
export const InsightSummary = lazy(
  () => import("./InsightsAdvanced/InsightSummary")
);
export const InsightsAdvacedList = lazy(() => import("./InsightsAdvanced"));

/*************************** OPEN ITEMS START **********************/

// OPEN ITEMS - ADMIN
export const AdminOpenItemsList = lazy(
  () => import("./OpenItems/Admin/AdminOpenItemsList")
);
export const AdminOpenItemAdd = lazy(
  () => import("./OpenItems/Admin/AdminOpenItemAdd")
);
export const AdminOpenItemSummary = lazy(
  () => import("./OpenItems/Admin/AdminOpenItemSummary")
);
export const AdminOpenItemEdit = lazy(
  () => import("./OpenItems/Admin/AdminOpenItemEdit")
);

// OPEN ITEMS - Client
export const ClientOpenItemsList = lazy(
  () => import("./OpenItems/Client/ClientOpenItemsList")
);
export const ClientViewOpenItem = lazy(
  () => import("./OpenItems/Client/ClientViewOpenItem")
);

/*************************** OPEN ITEMS END ***********************/

/* *************************** REPORTS START *************************** */

export const Reports = lazy(() => import("./Reports"));
export const LedgerStatement = lazy(() => import("./Reports/LedgerStatement"));
export const TrialBalance = lazy(() => import("./Reports/TrialBalance"));
export const DetailedTrialBalance = lazy(
  () => import("./Reports/DetailedTrialBalance")
);
export const ProfitLoss = lazy(() => import("./Reports/ProfitLoss"));
export const DetailedProfitLoss = lazy(
  () => import("./Reports/DetailedProfitLoss")
);
export const DetailedBalanceSheet = lazy(
  () => import("./Reports/DetailedBalanceSheet")
);
export const BalanceSheet = lazy(() => import("./Reports/BalanceSheet"));
export const StockReportSummary = lazy(
  () => import("./Reports/StockReportSummary")
);
export const StockStatement = lazy(() => import("./Reports/StockStatement"));
export const DayBook = lazy(() => import("./Reports/DayBook"));
export const GeneralLedger = lazy(
  () => import("./Reports/GeneralLedger/index")
);
export const CostOfGoods = lazy(() => import("./Reports/CostOfGoods/index"));
export const AgeingAnalysisReport = lazy(
  () => import("./Reports/AgeingAnalysisReport/index")
);
export const ReceiptAndPayment = lazy(
  () => import("./Reports/ReceiptAndPayment/index")
);
export const StockLimits = lazy(() => import("./Reports/StockLimits/index"));
export const BatchSummaryReport = lazy(
  () => import("./Reports/BatchSummary/index")
);
export const BatchVoucherReport = lazy(
  () => import("./Reports/BatchVoucher/index")
);
export const MonthlyLedgerSummary = lazy(
  () => import("./Reports/MonthlyLedgerSummary/index")
);
export const ExpensePerformance = lazy(
  () => import("./Reports/ExpensePerformance/index")
);
export const CompanyOverviewReport = lazy(
  () => import("./Reports/CompanyOverview/index")
);
export const SalesPerformance = lazy(
  () => import("./Reports/SalesPerformance/index")
);
export const NatureOfIncome = lazy(
  () => import("./Reports/NatureOfIncomeAndExpense/index")
);

export const RelatedParty = lazy(
  () => import("./Reports/RelatedPartyTransactionReport/index")
);

/**************************** REPORTS END ****************************/

/*************************** Client Settings Start ***********************/

export const ClientSettings = lazy(() => import("./ClientSettings"));

// Client Setting - Address Manager
export const AddressManager = lazy(
  () => import("./ClientSettings/AddressManager")
);
export const AddBusinessAddress = lazy(
  () => import("./ClientSettings/AddressManager/AddBusinessAddress")
);
export const EditBusinessAddress = lazy(
  () => import("./ClientSettings/AddressManager/EditBusinessAddress")
);

// Client Setting - Customer/Supplier
export const CustomerSupplierManager = lazy(
  () => import("./ClientSettings/CustomerSupplierManager")
);
export const AddCustomerSupplier = lazy(
  () => import("./ClientSettings/CustomerSupplierManager/AddCustomerSupplier")
);
export const EditCustomerSupplier = lazy(
  () => import("./ClientSettings/CustomerSupplierManager/EditCustomerSupplier")
);
export const CustomerSupplierBulkUpload = lazy(
  () =>
    import(
      "./ClientSettings/CustomerSupplierManager/CustomerSupplierBulkUpload"
    )
);
export const NewCustomersSuppliers = lazy(
  () => import("./ClientSettings/NewCustomersSuppliers")
);

// Client Setting - Accounts Manager
export const AccountsManager = lazy(
  () => import("./ClientSettings/AccountsManager")
);

// Client Setting - Stock Manager
export const StockManager = lazy(() => import("./ClientSettings/StockManager"));
export const StockGroupsList = lazy(
  () => import("./ClientSettings/StockManager/StockGroups")
);
export const StockItemsList = lazy(
  () => import("./ClientSettings/StockManager/StockItems")
);
export const AddStockItem = lazy(
  () => import("./ClientSettings/StockManager/StockItems/AddStockItem")
);
export const EditStockItemList = lazy(
  () => import("./ClientSettings/StockManager/StockItems/EditStockItemList")
);
export const UnitsOfMeasurement = lazy(
  () => import("./ClientSettings/StockManager/UnitsOfMeasurement")
);
export const StockItemBulkUpload = lazy(
  () => import("./ClientSettings/StockManager/StockItems/StockItemBulkUpload")
);

// Client Setting - Department
export const Department = lazy(
  () => import("./ClientSettings/Department/index")
);
export const BatchManagement = lazy(
  () => import("./ClientSettings/BatchManagement/index")
);
export const AddBatchManagement = lazy(
  () => import("./ClientSettings/BatchManagement/AddBatchManagement")
);
export const EditBatchManagement = lazy(
  () => import("./ClientSettings/BatchManagement/EditBatchManagement")
);

// Client Setting - General Setting
export const GeneralSetting = lazy(
  () => import("./ClientSettings/GeneralSetting/GeneralSetting")
);

/*************************** Client Settings End ***********************/

/********************** Client ID/Password Manager Start********************/
export const ClientIdPasswordManagerList = lazy(
  () => import("./IdPasswordManager/ClientIdPasswordManager/index")
);
export const AddIClientIdPasswordManager = lazy(
  () =>
    import(
      "./IdPasswordManager/ClientIdPasswordManager/AddClientIdPasswordManager"
    )
);
export const EditClientIdPasswordManager = lazy(
  () =>
    import(
      "./IdPasswordManager/ClientIdPasswordManager/EditClientIdPasswordManager"
    )
);
/********************** Client ID/Password Manager End********************/

/********************** GST Module Start ************************************/

export const GSTModule = lazy(() => import("./GSTModule"));
export const GstrOne = lazy(() => import("./GSTModule/GstrForms/GstrOne"));
export const GstOneFiling = lazy(
  () => import("./GSTModule/GSTOneFiling/GstOneFiling")
);
export const GstThreeBFiling = lazy(
  () => import("./GSTModule/GSTThreeBFiling/GstThreeBFiling")
);
export const GstrThreeB = lazy(
  () => import("./GSTModule/GstrForms/GstrThreeB")
);
export const GSTRSteps = lazy(() => import("./GSTModule/GSTRSteps/GSTRSteps"));

/********************** GST Module End ************************************/

/********************** FIXED Asset Register Start */

export const FixedAssetRegister = lazy(
  () => import("./FixedAssetRegister/index")
);
export const FixedAssetRegisterList = lazy(
  () => import("./FixedAssetRegister/FixedAssetRegister")
);
export const AddEditFixedAssetRegister = lazy(
  () =>
    import(
      "./FixedAssetRegister/AddEditFixedAssetRegister/AddEditFixedAssetRegister"
    )
);
export const FixedAssetBulkUpload = lazy(
  () => import("./FixedAssetRegister/FixedAssetBulkUpload")
);

// Physical Verification
export const PhysicalVerification = lazy(
  () => import("./PhysicalVerification/PhysicalVerification")
);
export const PhysicalVerificationIdentity = lazy(
  () => import("./PhysicalVerification/PhysicalVerificationIdentity")
);

/* Audit Session */
export const AuditSession = lazy(() => import("./AuditSession/index"));
export const AddAuditSession = lazy(
  () => import("./AuditSession/AddAuditSession/AddAuditSession")
);

/********************** FIXED Asset Register End **/

/********************** SOP Module Start ************************************/

export const SopModule = lazy(() => import("./SopModule/index"));
export const AddSopModule = lazy(() => import("./SopModule/AddSopModule"));
export const EditSopModule = lazy(() => import("./SopModule/EditSopModule"));

/********************** SOP Module End ************************************/

/********************** Scheduling Start********************/
export const Scheduling = lazy(() => import("./Scheduling/index"));
export const UserView = lazy(() => import("./Scheduling/UserView/index"));
export const ManagerView = lazy(() => import("./Scheduling/ManagerView/index"));
export const AllUsersSchedule = lazy(
  () => import("./Scheduling/ScheduleReports/AllUsersSchedule/index")
);
export const AllUsersApprovalPendingList = lazy(
  () => import("./Scheduling/ScheduleReports/AllUsersApprovalPendingList/index")
);
export const AllClientsSchedule = lazy(
  () => import("./Scheduling/ScheduleReports/AllClientsSchedule/index")
);
export const ManagerClientSchedule = lazy(
  () => import("./Scheduling/ScheduleReports/ManagerClientSchedule/index")
);
export const SchedulingReports = lazy(
  () => import("./Scheduling/ScheduleReports/index")
);
export const RequestView = lazy(
  () => import("./Scheduling/ManagerView/RequestView")
);
export const ClientVsUserScheduling = lazy(
  () => import("./Scheduling/ScheduleReports/ClientVsUserScheduling/index")
);
export const ClientJobSchedule = lazy(
  () => import("./Scheduling/ScheduleReports/ClientJobScheduling/index")
);
export const JobSpecificUsersReport = lazy(
  () => import("./Scheduling/ScheduleReports/JobSpecificUsersReport/index")
);
export const AvailabilityReport = lazy(
  () => import("./Scheduling/ScheduleReports/AvailabilityReport/index")
);
/********************** Scheduling End********************/

/********************** Jobs Start  *********************/

export const Jobs = lazy(() => import("./Jobs"));
export const JobsType = lazy(() => import("./Jobs/JobsType"));
export const AddJobType = lazy(
  () => import("./Jobs/JobsType/AddEditJobType/AddJobType")
);
export const AddJobs = lazy(() => import("./Jobs/Jobs/AddEditJobs/AddJobs"));
export const EditJobType = lazy(
  () => import("./Jobs/JobsType/AddEditJobType/EditJobType")
);
export const RecurringJobsSetting = lazy(
  () => import("./Jobs/RecurringJobsSetting/index")
);
export const AddRecurringJobsSetting = lazy(
  () => import("./Jobs/RecurringJobsSetting/AddRecurringJobSetting")
);
export const EditRecurringJobsSetting = lazy(
  () => import("./Jobs/RecurringJobsSetting/EditRecurringJobSetting")
);
export const JobsList = lazy(() => import("./Jobs/Jobs/index"));
export const EditJobs = lazy(() => import("./Jobs/Jobs/AddEditJobs/EditJobs"));
export const JobChecklist = lazy(
  () => import("./Jobs/JobChecklist/JobChecklist")
);
export const AddJobChecklist = lazy(
  () => import("./Jobs/JobChecklist/AddJobChecklist")
);
export const EditJobChecklist = lazy(
  () => import("./Jobs/JobChecklist/EditJobChecklist")
);
export const AllOpenJobChecklist = lazy(
  () => import("./Jobs/JobChecklist/AllOpenJobChecklist")
);
export const RecurringJobReport = lazy(
  () => import("./Jobs/RecurringJobReport/index")
);

/********************** Jobs End  **********************/

/********************** Services **********************/
export const Services = lazy(() => import("./Services/index"));
export const IFSC = lazy(() => import("./Services/IFSC"));
export const BankAccountInfo = lazy(() => import("./Services/BankAccountInfo"));
export const GstInfo = lazy(() => import("./Services/GstInfo"));
export const PanVerify = lazy(() => import("./Services/PanVerify"));
export const TanVerify = lazy(() => import("./Services/TanVerify"));
export const PanAadharLink = lazy(() => import("./Services/PanAadharLink"));

/********************** Services **********************/

/**************** Assign Columns ********************/
export const AssignColumns = lazy(
  () => import("./AssignColumns/AssignColumns")
);
export const AssignColumnsNew = lazy(
  () => import("./AssignColumnsNew/AssignColumnsNew")
);
/**************** Assign Columns ********************/

/**************** Assign Clients ******************/
export const AssignClients = lazy(
  () => import("./AssignClients/AssignClients")
);
/**************** Assign Clients ******************/

/**************** Admin Reports Start *****************/

export const AdminReports = lazy(() => import("./AdminReports"));
export const JobProgressReports = lazy(
  () => import("./AdminReports/JobProgressReports")
);
export const OpenItemsProgressReports = lazy(
  () => import("./AdminReports/OpenItemsProgressReports/index")
);
export const FileFolderCounterReports = lazy(
  () => import("./AdminReports/FileFolderCounterReports")
);
export const InvoicingAdvanceCounts = lazy(
  () => import("./AdminReports/InvoiceReports/InvoicingAdvanceCounts")
);
export const AssignedUsersOfClient = lazy(
  () => import("./AdminReports/AssignedUserOfClient")
);
export const ViewOpenItemsProgressReports = lazy(
  () =>
    import(
      "./AdminReports/OpenItemsProgressReports/ViewOpenItemsProgressReports"
    )
);
export const UserLoginSessionReport = lazy(
  () => import("./AdminReports/UserLoginSessionReports/index")
);
export const DailyActiveUser = lazy(
  () =>
    import("./AdminReports/UserLoginSessionReports/DailyActiveUserReport/index")
);
export const MonthlyActiveUser = lazy(
  () =>
    import(
      "./AdminReports/UserLoginSessionReports/MonthlyActiveUserReport/index"
    )
);
export const UserSessionLoginCount = lazy(
  () =>
    import(
      "./AdminReports/UserLoginSessionReports/UserSessionLoginCountReport/index"
    )
);
export const UserReport = lazy(
  () => import("./AdminReports/UserLoginSessionReports/UserReport/index")
);
export const InvoiceReports = lazy(
  () => import("./AdminReports/InvoiceReports/index")
);
export const UsersInvoicingCount = lazy(
  () => import("./AdminReports/InvoiceReports/UsersInvoicingCount/index")
);
export const AllClientSop = lazy(
  () => import("./AdminReports/AllClientsSop/AllClientsSop")
);
export const AllEwayBillList = lazy(
  () => import("./AdminReports/EwayBillEInvoiceList/AllEwayBillList")
);
export const AllEInvoiceList = lazy(
  () => import("./AdminReports/EwayBillEInvoiceList/AllEInvoiceList")
);
export const AllClientLockDateList = lazy(
  () => import("./AdminReports/AllClientLockDateReport/AllClientLockDateList")
);
export const AllExternalUserEmailers = lazy(
  () => import("./AdminReports/AllExternalUserEmailers/AllExternalUserEmailers")
);
export const AllUserApprovedEntry = lazy(
  () =>
    import(
      "./AdminReports/AllUsersApprovedEntryCountReport/AllUserApprovedEntry"
    )
);
export const BulkUploadReport = lazy(
  () => import("./AdminReports/BulkUploadReport/BulkUploadReport")
);
export const UserWiseOCRReport = lazy(
  () => import("./AdminReports/OCRReports/UserWiseOCRReport/UserWiseOCRReport")
);
export const ClientWiseOCRReport = lazy(
  () =>
    import("./AdminReports/OCRReports/ClientWiseOCRReport/ClientWiseOCRReport")
);
export const TicketingReport = lazy(
  () => import("./AdminReports/TicketingReport/TicketingReport")
);
export const OCRAnalysisReport = lazy(
  () =>
    import(
      "@/screens/AdminReports/OCRReports/OCRAnalysisReport/OCRAnalysisReport"
    )
);

/**************** Admin Reports End ******************/

/**************** All Users *************************/
export const AllUsersAndClients = lazy(() => import("./AllUsersAndClients"));
export const AddInternalExternalUser = lazy(
  () => import("./AllUsersAndClients/AllUserProfileAdd")
);
export const EditInternalExternalUser = lazy(
  () => import("./AllUsersAndClients/AllUserProfileEdit")
);
/**************** All Users *************************/

/************ All Open Jobs ************************/
export const UserOpenJobsListing = lazy(
  () => import("./UserOpenJobsListing/AllOpenJobs")
);
/************ All Open Jobs ************************/

/*********** Change Credentials ******************/
export const ChangeClientPassword = lazy(
  () => import("./ChangeClientPassword/ChangeClientPassword")
);
/*********** Change Credentials ******************/

/*********** User Management start ********/
export const UserManagement = lazy(() => import("./UserManagement"));
export const UserGroups = lazy(() => import("./UserManagement/UserGroups"));
export const AddEditUserGroup = lazy(
  () => import("./UserManagement/UserGroups/AddEditUserGroup")
);
export const AssignGroupsList = lazy(
  () => import("./UserManagement/AssignGroupsList")
);
export const AddEditMenuList = lazy(
  () => import("./UserManagement/AddEditMenuList")
);
export const AssignGroupToUser = lazy(
  () => import("./UserManagement/AssignGroupsList/AssignGroupToUser")
);
/*********** User Management end ********/

/********** Id Password Manager */
export const IdPasswordManagerList = lazy(
  () => import("./IdPasswordManager/index")
);
export const AddIdPasswordManager = lazy(
  () => import("./IdPasswordManager/AddIdPasswordManager")
);
export const EditIdPasswordManager = lazy(
  () => import("./IdPasswordManager/EditIdPasswordManager")
);
/********** Id Password Manager */

/*********** Disbursment Module  **************/
export const DisbursementModuleList = lazy(
  () => import("./DisbursementModule/index")
);
export const AddDisbursement = lazy(
  () => import("./DisbursementModule/AddDisbursement")
);
export const EditDisbursement = lazy(
  () => import("./DisbursementModule/EditDisbursement")
);
/*********** Disbursment Module  **************/

/************ Client Directory  **********/
export const ClientDirectory = lazy(() => import("./ClientDirectory/index"));
export const AddClient = lazy(() => import("./ClientDirectory/AddClient"));
export const EditClient = lazy(() => import("./ClientDirectory/EditClient"));
export const ViewClient = lazy(
  () => import("../components/ClientDirectory/ViewClient")
);
/************ Client Directory  **********/

/************* Master Data *****************/
export const MasterData = lazy(() => import("./MasterData/index"));
export const Branch = lazy(() => import("./MasterData/Branch/index"));
export const ClientGroup = lazy(() => import("./MasterData/ClientGroup/index"));
export const Email = lazy(() => import("./MasterData/Emailers/index"));
export const HolidayCalender = lazy(
  () => import("./MasterData/HolidayCalender/index")
);
export const Currency = lazy(() => import("./MasterData/Currency/index"));
export const ActivityCode = lazy(
  () => import("./MasterData/ActivityCode/index")
);
export const ClientCategory = lazy(
  () => import("./MasterData/ClientCategory/index")
);
export const UsersDepartment = lazy(
  () => import("./MasterData/UsersDepartment/index")
);
export const TdsAndTcsMaster = lazy(() => import("./MasterData/TdsMaster"));
export const EditTdsMaster = lazy(
  () => import("./MasterData/TdsMaster/EditTdsMaster")
);
export const AddTdsMaster = lazy(
  () => import("./MasterData/TdsMaster/AddTdsMaster")
);
export const SkillsAndQualification = lazy(
  () => import("./MasterData/SkillsAndQualificationMaster/index")
);
export const ScopeOfWork = lazy(() => import("./MasterData/ScopeOfWork/index"));
export const AddTcsMaster = lazy(
  () => import("./MasterData/TdsMaster/AddTcsMaster")
);
export const EditTcsMaster = lazy(
  () => import("./MasterData/TdsMaster/EditTcsMaster")
);
export const PdfTemplateMaster = lazy(
  () => import("./MasterData/PdfTemplateMaster")
);
export const JobTitle = lazy(() => import("./MasterData/JobTitle/index"));
export const TicketingMaster = lazy(() => import("./MasterData/Ticketing"));
export const PerformanceManagementKra = lazy(
  () => import("./MasterData/PerformanceManagement/KeyResultAreas/index")
);
export const PerformanceManagementKpi = lazy(
  () =>
    import("./MasterData/PerformanceManagement/KeyPerformanceIndicators/index")
);
export const AddKPI = lazy(
  () =>
    import("./MasterData/PerformanceManagement/KeyPerformanceIndicators/AddKPI")
);
export const EditKPI = lazy(
  () =>
    import(
      "./MasterData/PerformanceManagement/KeyPerformanceIndicators/EditKPI"
    )
);
/************* Master Data *****************/

/************** TimeSheet Start*****************/

export const TimeSheet = lazy(() => import("./TimeSheet"));

// Admin TimeSheet Report
export const TimeSheetAdminReport = lazy(
  () => import("./TimeSheetReports/TimeSheetAdminReport/index")
);
export const TimSheetSummaryReport = lazy(
  () => import("./TimeSheetReports/TimeSheetSummaryReport/index")
);
export const TimeSheetReports = lazy(() => import("./TimeSheetReports/index"));
export const TimeSheetVsSchedulingMonthlyReport = lazy(
  () => import("./TimeSheetReports/TimeSheetVsSchedulingMonthlyReport/index")
);
export const TimeSheetClientWiseUserReport = lazy(
  () => import("./TimeSheetReports/TimeSheetClientWiseUserReport")
);
export const TimesheetMonthWiseClientReport = lazy(
  () => import("./TimeSheetReports/TimesheetMonthWiseClientReport/index")
);
export const TimesheetClientWiseMonthlyReport = lazy(
  () => import("./TimeSheetReports/TimesheetClientWiseMonthlyReport/index")
);

export const AttendanceReport = lazy(
  () => import("./Attendance/AttendanceReport/AttendanceReport")
);
export const AllUserAttendanceReport = lazy(
  () => import("./Attendance/AttendanceReport/AllUserAttendanceReport")
);
/************** TimeSheet End*****************/

/************** Compliance Calendar *********/
export const ComplianceCalendar = lazy(
  () => import("./ComplianceCalendar/index")
);
/************** Compliance Calendar *********/

/************** Help Module ****************/
export const HelpModule = lazy(() => import("./HelpModule"));
/************** Help Module ****************/

/************** HRMS *********************/
export const HMRMS = lazy(() => import("./HRMS/index"));
export const HRDashboard = lazy(() => import("./HRMS/HRDashboard/index"));
export const RecruitmentModule = lazy(
  () => import("./HRMS/RecruitmentModule/index")
);
export const RecruitmentTracker = lazy(
  () => import("./HRMS/RecruitmentModule/OptimisedRecruitmentTracker/index")
);
export const OpenPosition = lazy(
  () => import("./HRMS/RecruitmentModule/OpenPosition/index")
);
export const AddRecruitmentTracker = lazy(
  () =>
    import(
      "./HRMS/RecruitmentModule/OptimisedRecruitmentTracker/AddRecruitmentTrackerContainer"
    )
);
export const EditRecruitmentTracker = lazy(
  () =>
    import(
      "./HRMS/RecruitmentModule/OptimisedRecruitmentTracker/EditRecruitmentTrackerContainer"
    )
);
export const HiringCheckList = lazy(
  () => import("./HRMS/RecruitmentModule/HiringCheckList/index")
);
export const AllUsersCheckInsReports = lazy(
  () => import("./HRMS/AllUsersCheckInsReports/index")
);
export const AllUserPerformanceEvaluationReport = lazy(
  () => import("./HRMS/AllUserPerformanceEvaluationReport/index")
);
export const AllUsersLeaveHistoryReport = lazy(
  () => import("./HRMS/AllUsersLeaveHistoryReport/index")
);
export const AllUsersRatingReport = lazy(
  () => import("./HRMS/AllUsersRatingReport/AllUsersRatingReport")
);
export const RecruitmentTrackerBulkUpload = lazy(
  () =>
    import(
      "./HRMS/RecruitmentModule/RecruitmentTracker/RecruitmentTrackerBulkUpload"
    )
);
export const ResignationUpdatesList = lazy(
  () => import("./HRMS/HRDashboard/ResignationUpdatesList")
);
export const PERatingReport = lazy(() => import("./HRMS/PERatingReport/index"));
/************** HRMS *********************/

/************** Lead Module *************/
export const LeadDirectory = lazy(() => import("./LeadModule/LeadDirectory"));
export const LeadModule = lazy(() => import("./LeadModule/LeadModule"));
export const ClientMeetUp = lazy(() => import("./LeadModule/ClientMeetUp"));
export const EditClientMeetUp = lazy(
  () => import("./LeadModule/ClientMeetUp/EditClientMeetUpChecklist")
);
export const AllClientMeetUpStatus = lazy(
  () => import("./LeadModule/ClientMeetUp/AllClientMeetUpStatus")
);
export const LeadModuleStageThresholdMaster = lazy(
  () => import("./LeadModule/LeadModuleStageThresholdMaster")
);
export const EditLeadModule = lazy(() => import("./LeadModule/EditLeadModule"));
/************** Lead Module *************/

/************* Things To do ************/
export const ThinksToDo = lazy(() => import("./ThinksToDo/index"));
export const InterviewAndApprovalPendingList = lazy(
  () => import("./ThinksToDo/InterviewAndApprovalPendingList")
);
/************* Things To do ************/

/************* Team's Directory *****************/
export const TeamDirectory = lazy(() => import("./TeamDirectory/index"));
/************* Team's Directory *****************/

/************* Expense Management ***************/
export const ExpenseManagement = lazy(() => import("./ExpenseManagement"));
export const RaiseExpenseHome = lazy(
  () => import("./ExpenseManagement/RaiseExpense")
);
export const ApproveExepnseHome = lazy(
  () => import("./ExpenseManagement/ApproveExpense")
);
/************* Expense Management ***************/

/****** Support *********/
export const SupportPage = lazy(() => import("./SupportPage/SupportPage"));
/****** Support *********/

/********** Goverment Directory **********/
export const GovermentDirectory = lazy(
  () => import("./GovermentDirectory/index")
);
export const ViewAllMappedJobs = lazy(
  () => import("./GovermentDirectory/ViewAllMappedJobs")
);
/********** Goverment Directory **********/

/**************** Error *******/
export const ErrorPage = lazy(() => import("./ErrorPage"));
export const Unauthorize = lazy(() => import("./Unauthorize"));
/**************** Error *******/

/************* Schedule Maintenance *************/
export const ScheduleMaintenance = lazy(() => import("./ScheduleMaintenance"));
export const ScheduledBanner = lazy(
  () => import("./ScheduleMaintenance/ScheduledBanner")
);
/************* Schedule Maintenance *************/

/******************* Attendance *******************/
export const Attendance = lazy(() => import("./Attendance/index"));
/******************* Attendance *******************/

/******************* App Version Control *******************/
export const AppVersionControl = lazy(() => import("./AppVersionControl"));
/******************* App Version Control *******************/

// TDS/TCS Management

export const TdsTcsManagement = lazy(() => import("./TdsTcsManagement"));
export const TdsForm = lazy(() => import("./TdsTcsManagement/TdsForm"));
